import { useNavigationItems } from '../model';
import { SidebarNavigationItem } from './SidebarNavigationItem';

type Props = {
  onClose: () => void;
};

const SidebarNavigationMobile = ({ onClose }: Props) => {
  const { navItems, activeNavItem } = useNavigationItems();
  return (
    <div className="rounded-4xl p-[1.6rem] space-y-[1.6rem] bg-secondary-bg">
      <div className="space-y-[0.8rem]">
        {navItems.map(item => (
          <SidebarNavigationItem
            key={item.label}
            isActive={activeNavItem === item.href}
            {...item}
            onClick={() => {
              if (item.onClick) {
                item.onClick();
              }
              onClose();
            }}
          />
        ))}
      </div>
    </div>
  );
};

export { SidebarNavigationMobile };
